import React, { useEffect, useState } from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import {
    CartesianGrid,
    Legend,
    Line,
    LineChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from "recharts";

import { apiFetch } from "../../../../apiBindings";
import HeadlineItem from "../ContentElement/HeadlineItem";
import { SideNavContainer } from "../SideNavContainer";
import useSideNavStore from "../SideNavContainer/store";

const Container = styled.div``;

const ContentContainer = styled.div`
    ${({ theme }) => css`
        ${theme.paddings.containerOuter.right}
        ${theme.paddings.containerOuter.left}
    `}
`;

const ChartWrapper = styled.div`
    width: 100%;
    height: 500px;
`;

const Headline = styled(HeadlineItem)``;

const LngChart = ({ name, text }) => {
    const theme = useTheme();
    const [paddingLeft] = useSideNavStore((state) => [state.paddingLeft]);
    const [series, setSeries] = useState([]);

    const getData = () => {
        apiFetch("/chart")
            .then((response) => response.json())
            .then((response) => {
                setSeries(
                    response.data.map((item) => {
                        if (item.key === "heatingOil") {
                            return {
                                name: "Heizöl",
                                color: theme.colors.blue.toString(),
                                data: JSON.parse(item.value).map((item) => {
                                    return {
                                        month: item.month,
                                        value: Number(item.value),
                                    };
                                }),
                            };
                        }
                        if (item.key === "gas") {
                            return {
                                name: "Erdgas",
                                color: theme.colors.red.toString(),
                                data: JSON.parse(item.value).map((item) => {
                                    return {
                                        month: item.month,
                                        value: Number(item.value),
                                    };
                                }),
                            };
                        }
                        if (item.key === "lng") {
                            return {
                                name: "Flüssiggas",
                                color: "#D1BD2FFF",
                                data: JSON.parse(item.value).map((item) => {
                                    return {
                                        month: item.month,
                                        value: Number(item.value),
                                    };
                                }),
                            };
                        } else {
                            return {};
                        }
                    })
                );
            });
    };

    useEffect(() => {
        getData();
    }, []);

    return (
        <Container>
            <ContentContainer>
                <SideNavContainer paddingLeft={paddingLeft}>
                    {name && (
                        <Headline
                            headline={3}
                            color={theme.colors.red.toString()}
                        >
                            {name}
                        </Headline>
                    )}
                    <ChartWrapper>
                        <ResponsiveContainer>
                            <LineChart>
                                <CartesianGrid vertical={false} />
                                <XAxis
                                    dataKey="month"
                                    type="category"
                                    allowDuplicatedCategory={false}
                                    padding={{ right: 30 }}
                                />
                                <YAxis
                                    dataKey="value"
                                    label={{
                                        value: "Preis in €",
                                        angle: -90,
                                        position: "insideLeft",
                                    }}
                                />
                                <Legend verticalAlign="top" height={36} />
                                {series.map((s) => (
                                    <Line
                                        stroke={s.color}
                                        strokeWidth={2}
                                        dataKey="value"
                                        data={s.data}
                                        name={s.name}
                                        key={s.name}
                                    />
                                ))}
                            </LineChart>
                        </ResponsiveContainer>
                    </ChartWrapper>
                </SideNavContainer>
            </ContentContainer>
        </Container>
    );
};

export default LngChart;
